// src/components/kuestion/shared/tokenClaims.js
//
// Reads the `mode` claim from the user JWT (backend reply, 17 Sep 2026 §4).
// The claim is written on every token mint: "solo", "campus", or null for an
// account that has not chosen. A token minted before the claim existed has the
// key ABSENT, which means unknown, not unchosen.
//
// The client only routes on this. It never verifies the signature and never
// needs to: the server checks the token on every request that matters.
export function modeClaim(token) {
  try {
    const part = String(token || '').split('.')[1];
    if (!part) return { present: false, mode: undefined };
    const b64 = part.split('-').join('+').split('_').join('/');
    const payload = JSON.parse(decodeURIComponent(escape(atob(b64 + '='.repeat((4 - (b64.length % 4)) % 4)))));
    if (!payload || !Object.prototype.hasOwnProperty.call(payload, 'mode')) return { present: false, mode: undefined };
    const m = payload.mode;
    return { present: true, mode: m === 'solo' || m === 'campus' ? m : null };
  } catch {
    return { present: false, mode: undefined };
  }
}
